<template>
    <Carousel v-bind="settings" :breakpoints="breakpoints">
        <Slide v-for="(post, index) in posts" :key="post.id">
            <div class="card px-2">
                <div class="bloco-w d-flex flex-column align-items-center justify-content-center">
                    <img :class="styleClass(index)" :src="`${post.cover}`" :alt="post.title" @click="$emit('showModalEcard', true, post)" width="387" height="588">
                </div>
                <div class="card-body d-flex flex-column align-items-start">
                    <h5 class="card-title">{{ post.title }}</h5>
                    <div class="button--more" @click="$emit('showModalEcard', true, post)">
                        {{ translate.shootModel }} <font-awesome-icon :icon="['fas', 'arrow-right']" size="sm"
                            style="margin-left: 8px" />
                    </div>
                </div>
            </div>
        </Slide>

        <template #addons>
            <Pagination />
        </template>
    </Carousel>
</template>

<script lang="ts">
  import { mapState } from 'pinia'
  import { defineComponent } from 'vue'
  import { Carousel, Slide, Pagination } from 'vue3-carousel'
  import modelsTradutor from 'tradutors/ecards'

  import 'vue3-carousel/dist/carousel.css'
  import { localeStore } from 'stores/locale'

  export default defineComponent({
    name: 'CarroselEcards',
    components: {
      Carousel,
      Slide,
      Pagination
    },
    emits: ['showModalEcard'],
    props: ['posts'],
    computed: {
      ...mapState(localeStore, ['locale']),
      translate: function () {
        if (this.locale === 'pt-br') {
          return modelsTradutor.portugues
        } else {
          return modelsTradutor.ingles
        }
      }
    },
    data: () => ({
        // carousel settings
        settings: {
            itemsToShow: 2.2,
            snapAlign: 'center',
        },
        // breakpoints are mobile first
        // any settings not specified will fallback to the carousel settings
        breakpoints: {
            // 700px and up
            700: {
                itemsToShow: 2.5,
                snapAlign: 'center',
            },
            // 1024 and up
            1024: {
                itemsToShow: 2.5,
                snapAlign: 'start',
            },
        },
        // 1024 and up
        1024: {
          itemsToShow: 2.5,
          snapAlign: 'start'
        }
    }),
    methods: {
      styleClass(index) {
        return 'cursor-pointer vertical'
        // return index % 2 == 0 ? 'vertical' : 'horizontal'
      }
    }
  })
</script>
<style scoped>
.card-title {
  height: 28px;
  color: #B20000;
  font-family: 'Roboto-Medium';
  font-size: 24px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 28px;    
}

.button--more svg {
  color: #b20000;
}

.button--more {
  height: 19px;
  color: #5b5858;
  font-family: "Exo-2";
  font-size: 16px;
  letter-spacing: 0;
  line-height: 19px;
  text-align: right;  
  cursor: pointer;
}

.small svg {
  margin-right: 5px;
}

.bloco-w {
  height: 588px;
}

.horizontal {
  width: 543px;
  height: 404px;
}

.vertical {
  width: 100%;
  max-width: 387px;
  height: 588px;
}

.card {
  background-color: #f8f8f8;
}

.card-body {
  padding: 20px 0px;
}

:deep(.carousel__pagination-button::after) {
    display: block;
    content: '';
    width: 8px;
    height: 8px;
    border-radius: 50%;
    opacity: 0.2;
    background-color: #000000;
    margin-right: 15px;
}

:deep(.carousel__pagination-button--active) {
  background-color: #000000;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 15px;
  top: 2px;
}

/* regras mobile 769vp */
@media screen and (max-width: 769px) {

    .horizontal {
        width: 100%;
        height: unset;
    }

    .vertical {
        width: 100%;
        height: unset;
    }    
    .bloco-w{
        height: unset;
    }    

    .card-title {
        font-family: 'Exo-2';
        font-weight: 300;
        color: #898989;
        font-size: 16px;
    }    
    .button--more {
        font-size: 12px;
    }
}
</style>
